import { createSelector } from '@reduxjs/toolkit';

import { ConnectionStatus, RegistrationStatus } from './sipConnectionSlice';

import type { RootState } from 'features/app/store/store';

// Base selectors
export const selectSipConnection = (state: RootState) => state.sipConnection;

export const selectConnectionStatus = (state: RootState) =>
  state.sipConnection.connectionStatus;

export const selectRegistrationStatus = (state: RootState) =>
  state.sipConnection.registrationStatus;

export const selectRegistrationWanted = (state: RootState) =>
  state.sipConnection.registrationWanted;

// Derived selectors
export const selectIsSipRegistered = createSelector(
  [selectRegistrationStatus],
  (registrationStatus) => registrationStatus === RegistrationStatus.Registered
);

export const selectIsSipConnecting = createSelector(
  [selectConnectionStatus, selectRegistrationStatus],
  (connectionStatus, registrationStatus) =>
    connectionStatus === ConnectionStatus.Connecting ||
    registrationStatus === RegistrationStatus.Registering
);
